import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function NotInstalledP1DoorSticker({ navigation }) {
  const [details, setDetails] = useState({
    not_visible_p1_door_sticker_description: "",
    p1_door_sticker_not_visible_reason: "",
    other_reason_p1_door_sticker_not_visible: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    newErrors.p1_door_sticker_not_visible_reason = !details.p1_door_sticker_not_visible_reason;
    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validate()) {
      // Navigate to Maya SQR Solution after completing not installed door sticker form
      navigation.go('maya-sqr-solution');
    }
  };

  const handleBack = () => {
    navigation.previous();
  };


  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">Not Installed P1 Door Sticker</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                

                  {/* Reason P1 door sticker not visible */}
                  <Form.Group className={`mb-4 ${errors.p1_door_sticker_not_visible_reason ? 'form-group-error' : ''}`}>
                    <Form.Label className="form-label">
                      Reason P1 door sticker not installed <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {[
                        "HO restriction",
                        "mall restriction",
                        "marketing Restriction",
                        "competitor priority, specify ACQUIRER",
                        "TAS has no on-hand door sticker",
                        "no area/space to display",
                        "other reason",
                        "has P1 door sticker already"
                      ].map((reason) => (
                        <div key={reason} className={`form-radio-item${details.p1_door_sticker_not_visible_reason === reason ? " selected" : ""}`}>
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="p1_door_sticker_not_visible_reason"
                              value={reason}
                              label={reason}
                              checked={details.p1_door_sticker_not_visible_reason === reason}
                              onChange={handleChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {errors.p1_door_sticker_not_visible_reason && (
                      <div className="form-error">
                        Required
                      </div>
                    )}
                  </Form.Group>

                  {/* Other reason P1 door sticker not visible */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Other reason P1 door sticker not installed
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="other_reason_p1_door_sticker_not_visible"
                      value={details.other_reason_p1_door_sticker_not_visible || ''}
                      onChange={handleChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                <div className="form-nav-btns">
                  <AppButton
                    onClick={handleBack}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back
                  </AppButton>
                  <AppButton
                    onClick={handleSubmit}
                    variant="next"
                    className="form-btn variant-primary"
                  >
                     Next →
                  </AppButton>
                </div>
              </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default NotInstalledP1DoorSticker;
